import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Image.scss';

class Image extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: null,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    if (this.el.complete) {
      this.onImageLoad();
    }
  }

  onImageLoad = () => {
    this.setState({ loaded: true });
  };

  render() {
    const { className, ...props } = this.props;
    const rootClassName = classNames(className, 'image', {
      'image-loaded': this.state.loaded,
    });
    return (
      <div className={rootClassName}>
        <img
          ref={el => {
            this.el = el;
          }}
          onLoad={this.onImageLoad}
          alt=""
          {...props}
        />
      </div>
    );
  }
}

export default withStyles(s)(Image);



// WEBPACK FOOTER //
// ./src/components/Image/Image.js